export default __webpack_public_path__ + "static/media/CareLogic-Mobile.33ac4016.png";